import { SignupAudience, SignupField } from '../types/signup';

export const signupFields: Record<SignupAudience, SignupField[]> = {
  gigs: [
    { name: 'fullName', label: 'Full name', type: 'text', placeholder: 'Ana Souza', required: true, autoComplete: 'name' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'ana@email.com', required: true, autoComplete: 'email' },
    { name: 'city', label: 'City', type: 'text', placeholder: 'São Paulo, Brazil', required: true, autoComplete: 'address-level2' },
  ],
  company: [
    { name: 'fullName', label: 'Full name', type: 'text', placeholder: 'Alex Kim', required: true, autoComplete: 'name' },
    { name: 'email', label: 'Work email', type: 'email', placeholder: 'alex@company.com', required: true, autoComplete: 'email' },
    { name: 'company', label: 'Company', type: 'text', placeholder: 'Acme Inc.', required: true, autoComplete: 'organization' },
    { name: 'markets', label: 'Where do you need people?', type: 'text', placeholder: 'Mexico, Brazil, Nigeria', required: true },
    {
      name: 'useCase',
      label: 'What kind of tasks?',
      type: 'select',
      required: true,
      options: ['Payments testing', 'Mystery shopping', 'Store & retail checks', 'Deliveries & errands', 'Something else'],
    },
  ],
};

export const signupCopy: Record<SignupAudience, { tab: string; title: string; button: string; success: (name: string, values: Record<string, string>) => string }> = {
  gigs: {
    tab: 'I want gigs',
    title: 'Get paid for quick tasks in your city.',
    button: 'Join as a tasker',
    success: (name, v) => `You're in, ${name}. We'll email you as soon as gigs open in ${v.city || 'your city'}.`,
  },
  company: {
    tab: "I'm a company",
    title: 'Get verified locals on the ground.',
    button: 'Request early access',
    success: (name) => `Thanks, ${name}. We'll reach out within 24 hours to set up your first task.`,
  },
};
